<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.data0">
            <div class="item">活动名称：{{form.beforeStr.data0.activity_name}}</div>
            <div class="item">活动方式：{{form.beforeStr.data0.activity_way === 1?'指定商品':(form.beforeStr.data0.activity_way === 2?'平台满赠':'')}}</div>
            <div class="item">是否限制时间：{{form.beforeStr.data0.time_limit === 1?'限制':'不限制'}}</div>
            <div class="item">活动规则：{{form.beforeStr.data0.activity_rule}}</div>
            <div class="item">活动类型：{{form.beforeStr.data0.activity_type === 1?'满件赠':(form.beforeStr.data0.activity_type === 2?'满金额赠':'')}}</div>
            <div class="item">赠送方式：{{form.beforeStr.data0.giving_way === 1?'平台随机赠送':(form.beforeStr.data0.giving_way === 2?'客户自定赠送商品':'')}}</div>
            <div class="item">是否叠加条件：{{form.beforeStr.data0.activity_condition?'叠加':'不叠加'}}</div>
            <div class="item">状态：{{form.beforeStr.data0.activity_status?'上架':'下架'}}</div>
            <div class="item">参与活动身份：{{levelText(form.beforeStr.data1)}}</div>
            <div class="item">参与活动条件：{{moduleText(form.beforeStr.data0.activity_modules)}}</div>
            <div class="item">参与付款方式：{{payModesText(form.beforeStr.data0.pay_modes, form.beforeStr.data0.activity_modules) || '-'}}</div>
            <template v-if="form.beforeStr.data4">
              <div class="item">赠送规则：</div>
              <div class="item"><el-table :data="form.beforeStr.data4">
                  <el-table-column label="赠送门槛" prop="fullNum" align="center">
                    <template slot-scope="{row}">
                      满{{row.full_num}}{{form.beforeStr.data0.activity_type === 1?'件':'元'}}
                    </template>
                  </el-table-column>
                  <el-table-column label="赠送内容" align="center">
                    <template slot-scope="{row}">{{rewardOf(row)}}</template>
                  </el-table-column>
                </el-table></div>
            </template>

          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.data0">
            <div class="item">活动名称：{{form.afterStr.data0.activity_name}}</div>
            <div class="item">活动方式：{{form.afterStr.data0.activity_way === 1?'指定商品':(form.afterStr.data0.activity_way === 2?'平台满赠':'')}}</div>
            <div class="item">是否限制时间：{{form.afterStr.data0.time_limit === 1?'限制':'不限制'}}</div>
            <div class="item">活动规则：{{form.afterStr.data0.activity_rule}}</div>
            <div class="item">活动类型：{{form.afterStr.data0.activity_type === 1?'满件赠':(form.afterStr.data0.activity_type === 2?'满金额赠':'')}}</div>
            <div class="item">赠送方式：{{form.afterStr.data0.giving_way === 1?'平台随机赠送':(form.afterStr.data0.giving_way === 2?'客户自定赠送商品':'')}}</div>
            <div class="item">是否叠加条件：{{form.afterStr.data0.activity_condition?'叠加':'不叠加'}}</div>
            <div class="item">状态：{{form.afterStr.data0.activity_status?'上架':'下架'}}</div>
            <div class="item">参与活动身份：{{levelText(form.afterStr.data1)}}</div>
            <div class="item">参与活动条件：{{moduleText(form.afterStr.data0.activity_modules)}}</div>
            <div class="item">参与付款方式：{{payModesText(form.afterStr.data0.pay_modes, form.afterStr.data0.activity_modules) || '-'}}</div>
            <template v-if="form.afterStr.data4">
              <div class="item">赠送规则：</div>
              <div class="item"><el-table :data="form.afterStr.data4">
                  <el-table-column label="赠送门槛" prop="fullNum" align="center">
                    <template slot-scope="{row}">
                      满{{row.full_num}}{{form.afterStr.data0.activity_type === 1?'件':'元'}}
                    </template>
                  </el-table-column>
                  <el-table-column label="赠送内容" align="center">
                    <template slot-scope="{row}">{{rewardOf(row)}}</template>
                  </el-table-column>
                </el-table></div>
            </template>

          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import customerLevelApi from '@/api/sys/customerLevel'
import { MODULE_NAMES, payModesText, rewardText } from '@/views/goods/activity/activityEnum'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      levelNames: {}
    }
  },
  created() {
    this.getLogShow()
    customerLevelApi.fetchList().then(({ data }) => {
      const names = {}
      ;(data || []).forEach(item => { names[item.id] = item.name })
      this.levelNames = names
    })
  },
  methods: {
    payModesText,
    // 日志快照 data1 是 goods_activity_customer_level 行，只有等级 id
    levelText(rows) {
      if (!Array.isArray(rows) || !rows.length) return '-'
      return rows.map(row => this.levelNames[row.customer_level_id] || ('等级' + row.customer_level_id)).join('、')
    },
    moduleText(modules) {
      if (!modules) return '-'
      return String(modules).split(',').map(key => MODULE_NAMES[key.trim()] || key).join('、')
    },
    // 余额/零售价/学费赠送是按金额送，实物才按件数
    rewardOf(row) {
      return rewardText({ rewardType: row.reward_type, rewardValue: row.reward_value == null ? 0 : Number(row.reward_value), giftNum: row.gift_num })
    },
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
